import { render, staticRenderFns } from "./MaterialRatioDialog.vue?vue&type=template&id=3c131e63&scoped=true"
import script from "./MaterialRatioDialog.vue?vue&type=script&lang=js"
export * from "./MaterialRatioDialog.vue?vue&type=script&lang=js"
import style0 from "./MaterialRatioDialog.vue?vue&type=style&index=0&id=3c131e63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c131e63",
  null
  
)

export default component.exports